export const MENSAGEM_EMAIL_INVALIDO = 'E-mail inválido'

export const MENSAGEM_CPF_INVALIDO = 'CPF inválido'

export const MENSAGEM_NOME_SOBRENOME_INVALIDO = 'Por favor, preencha com nome e sobrenome'

export const MENSAGEM_NOME_SOBRENOME_CARACTERES = 'Apenas letras e espaços'

export const MENSAGEM_TELEFONE_INVALIDO = 'Telefone inválido'

export const MENSAGEM_NASCIMENTO_INVALIDA = 'Data de nascimento inválida'

export const MENSAGEM_TAMANHO_SENHA = 'Mínimo de 8 caracteres'

export const MENSAGEM_LETRA_MAIUSCULA_SENHA = 'Pelo menos 1 letra maiúscula'

export const MENSAGEM_LETRA_MINUSCULA_SENHA = 'Pelo menos 1 letra minúscula'

export const MENSAGEM_NUMERO_SENHA = 'Pelo menos 1 número'

export const MENSAGEM_CARACTERE_ESPECIAL_SENHA = '1 símbolo (ex: ! @ # $ %)'

export const MENSAGEM_ERRO_PROMOCAO = 'Promoção inválida'
